import PropTypes from 'prop-types';

const ResetPasswordPropTypes = {
  resetPassword: PropTypes.func,
};

export default ResetPasswordPropTypes;
